<template>
    <div>
        <v-card>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Eleos-Tracking Time Diff
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="data"
                :search="search"
                dense
            >
                <template v-slot:item.terminalEntry="{ item }">
                    <div class="text-center" style="margin-right: 50px;">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-width="1300"
                            offset-x
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-eye-outline</v-icon>
                            </template>

                            <v-card>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    TerminalName
                                                </th>
                                                <th>
                                                    TStartEleos
                                                </th>
                                                <th>
                                                    TStartTracking
                                                </th>
                                                <th>
                                                    TStartDiffSec
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ item.TerminalName }}</td>
                                                <td>{{ item.TStartEleos }}</td>
                                                <td>{{ item.TStartTracking }}</td>
                                                <td>{{ item.TStartDiffSec }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-menu>
                    </div>
                </template>

                <template v-slot:item.terminalExit="{ item }">
                    <div class="text-center" style="margin-right: 50px;">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-width="1300"
                            offset-x
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-eye-outline</v-icon>
                            </template>

                            <v-card>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    TerminalName
                                                </th>
                                                <th>
                                                    TEndEleos
                                                </th>
                                                <th>
                                                    TEndTracking
                                                </th>
                                                <th>
                                                    TEndDiffSec
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ item.TerminalName }}</td>
                                                <td>{{ item.TEndEleos }}</td>
                                                <td>{{ item.TEndTracking }}</td>
                                                <td>{{ item.TEndDiffSec }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-menu>
                    </div>
                </template>

                <template v-slot:item.stationEntry="{ item }">
                    <div class="text-center" style="margin-right: 50px;">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-width="1300"
                            offset-x
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-eye-outline</v-icon>
                            </template>

                            <v-card>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    StationName
                                                </th>
                                                <th>
                                                    StStartEleos
                                                </th>
                                                <th>
                                                    StStartTracking
                                                </th>
                                                <th>
                                                    StStartDiffSec
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ item.StationName }}</td>
                                                <td>{{ item.StStartEleos }}</td>
                                                <td>{{ item.StStartTracking }}</td>
                                                <td>{{ item.StStartDiffSec }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-menu>
                    </div>
                </template>

                <template v-slot:item.stationExit="{ item }">
                    <div class="text-center" style="margin-right: 50px;">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-width="1300"
                            offset-x
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-eye-outline</v-icon>
                            </template>

                            <v-card>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    StationName
                                                </th>
                                                <th>
                                                    StEndEleos
                                                </th>
                                                <th>
                                                    StEndTracking
                                                </th>
                                                <th>
                                                    StEndDiffSec
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ item.StationName }}</td>
                                                <td>{{ item.StEndEleos }}</td>
                                                <td>{{ item.StEndTracking }}</td>
                                                <td>{{ item.StEndDiffSec }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: [],
    components: {

    },
    data: function () {
        return {
            data: [],
            search: '',
            headers: [
                { text: 'ShiftDate', value: 'ShiftDate' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'OrderID', value: 'OrderID' },
                { text: 'LoadNum', value: 'LoadNum' },
                { text: 'OrderStatus', value: 'OrderStatus' },
                { text: 'Driver', value: 'DriverName' },
                { text: 'Truck', value: 'TruckName' },
                { text: 'Terminal Entry', value: 'terminalEntry' },
                { text: 'Terminal Exit', value: 'terminalExit' },
                { text: 'Station Entry', value: 'stationEntry' },
                { text: 'Station Exit', value: 'stationExit' },
                //{ text: 'Trailer', value: 'TrailerName' },
                /*{ text: 'TerminalName', value: 'TerminalName' },
                { text: 'TerminalEntryDate', value: 'TerminalEntryDate' },
                { text: 'TerminalEntryLatitude', value: 'TerminalEntryLatitude' },
                { text: 'TerminalEntryLongitude', value: 'TerminalEntryLongitude' },
                { text: 'TerminalEntryOdometer', value: 'TerminalEntryOdometer' },
                { text: 'TerminalEntryFuelLevel', value: 'TerminalEntryFuelLevel' },
                { text: 'TerminalExitDate', value: 'TerminalExitDate' },
                { text: 'TerminalExitLatitude', value: 'TerminalExitLatitude' },
                { text: 'TerminalExitLongitude', value: 'TerminalExitLongitude' },
                { text: 'TerminalExitOdometer', value: 'TerminalExitOdometer' },
                { text: 'TerminalExitFuelLevel', value: 'TerminalExitFuelLevel' },
                { text: 'StationName', value: 'StationName' },
                { text: 'StationEntryDate', value: 'StationEntryDate' },
                { text: 'StationEntryLatitude', value: 'StationEntryLatitude' },
                { text: 'StationEntryLongitude', value: 'StationEntryLongitude' },
                { text: 'StationEntryOdometer', value: 'StationEntryOdometer' },
                { text: 'StationEntryFuelLevel', value: 'StationEntryFuelLevel' },
                { text: 'StationExitDate', value: 'StationExitDate' },
                { text: 'StationExitLatitude', value: 'StationExitLatitude' },
                { text: 'StationExitLongitude', value: 'StationExitLongitude' },
                { text: 'StationExitOdometer', value: 'StationExitOdometer' },
                { text: 'StationExitFuelLevel', value: 'StationExitFuelLevel' },*/
                //{ text: 'DriverScanDate', value: 'DriverScanDate' },
            ],
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData: async function() {
            console.log("loadData");
            var str = this.$store;
            str.state.isLoading = true;
            await axios
                .get('geofences/data', {
                    headers: {
                        Authorization:
                            'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    //console.log(response.data);
                    this.data = response.data;
                    console.log(this.data);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                    str.state.isLoading = false;
                });
        }
    },
};
</script>

<style>
/* Styles here */
</style>